import { ScrollableModal } from '@/components/widgets/scrollable-modal'
import { Icon } from '@/components/icons/svg-icons'
import { Button } from '@nf/ui'
import clsx from 'clsx'
import { jupiterButton } from 'styled-system/recipes'
import { confirmModalStyles } from './confirm-modal.style'
import { useTranslations } from 'next-intl'

export const ConfirmModal = ({
	isOpen,
	text,
	title,
	canClose = true,
	setIsOpen,
	handleConfirm,
	handleCancel
}: {
	isOpen: boolean,
	text: string,
	title: string,
	canClose?: boolean,
	setIsOpen: (v: boolean) => void,
	handleConfirm?: () => void,
	handleCancel?: () => void,
}) => {
	const t = useTranslations('General');
	const onCancel = () => {
		setIsOpen(false);
		handleCancel && handleCancel();
	}
	return (
		<ScrollableModal
			sectionName={confirmModalStyles.section}
			className={confirmModalStyles.modal}
			isOpen={isOpen}
			closeModal={() => {
				canClose && onCancel();
			}}
			header={
				<header className={confirmModalStyles.header}>
					<h1 className={confirmModalStyles.headerTitle}>{title}</h1>
					{canClose ? (
						<div className={confirmModalStyles.iconClose} onClick={onCancel}>
							<Icon name="close-big" />
						</div>
					): null}
				</header>
			}
		>
			<div className={confirmModalStyles.root}>
				<div className={confirmModalStyles.content}>
					<div className={confirmModalStyles.formContainer}>
						<div className={confirmModalStyles.customText} dangerouslySetInnerHTML={{ __html: text }} />
						<div className={confirmModalStyles.buttonContainer}>
							<button 
								type="button" 
								className={clsx(jupiterButton({ size: 'lg', visual: 'cancel' }), confirmModalStyles.prevButton)} 
								onClick={onCancel}
							>
								<span>{t('lbl_cancel')}</span>
							</button>
							<Button 
								className={clsx(jupiterButton({ size: 'lg' }), confirmModalStyles.nextButton)} 
								onClick={handleConfirm}
							>
								{t('lbl_Confirmation')}
							</Button>
						</div>
					</div>
				</div>
			</div>
		</ScrollableModal>
	)
}